import "./BakeryStats.css";
import {
  MdBakeryDining,
  MdCheckCircle,
  MdStar,
  MdCancel,
} from "react-icons/md";

function BakeryStats({ products = [] }) {
  const total = products.length;

  const available = products.filter(
    (item) => item.isAvailable
  ).length;

  const bestSeller = products.filter(
    (item) => item.isBestSeller
  ).length;

  const outOfStock = products.filter(
    (item) =>
      item.stockStatus === "Out of Stock" ||
      Number(item.stock) <= 0
  ).length;

  const stats = [
    {
      title: "Total Products",
      value: total,
      icon: <MdBakeryDining />,
      className: "total",
    },
    {
      title: "Available",
      value: available,
      icon: <MdCheckCircle />,
      className: "available",
    },
    {
      title: "Best Sellers",
      value: bestSeller,
      icon: <MdStar />,
      className: "bestseller",
    },
    {
      title: "Out of Stock",
      value: outOfStock,
      icon: <MdCancel />,
      className: "outofstock",
    },
  ];

  return (
    <div className="bakery-stats">
      {stats.map((item, index) => (
        <div
          key={index}
          className={`bakery-stat-card ${item.className}`}
        >
          <div className="stat-icon">{item.icon}</div>

          <div className="stat-content">
            <h2>{item.value}</h2>
            <p>{item.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default BakeryStats;